var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 178,
    viewBox: "0 0 318 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 1,
    y: 0.5,
    width: 316,
    height: 177,
    rx: 5.5,
    fill: "#F2F2F2",
    stroke: "#303141",
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.525 80H161.509L163.261 81.6702L165.849 81.6702C166.543 81.6702 167.214 81.9327 167.713 82.4085C168.214 82.8852 168.5 83.5379 168.5 84.2246V94.5C168.5 95.1867 168.214 95.8394 167.713 96.3161C167.214 96.7919 166.543 97.0544 165.849 97.0544H151.151C150.457 97.0544 149.786 96.7919 149.287 96.3161C148.786 95.8394 148.5 95.1867 148.5 94.5V84.2246C148.5 83.5379 148.786 82.8852 149.287 82.4085C149.786 81.9327 150.457 81.6702 151.151 81.6702L153.772 81.6702L155.525 80ZM156.252 81.7684L154.5 83.4386L151.151 83.4386C150.915 83.4386 150.695 83.528 150.537 83.6787C150.38 83.8284 150.297 84.0254 150.297 84.2246V94.5C150.297 94.6992 150.38 94.8962 150.537 95.0459C150.695 95.1965 150.915 95.286 151.151 95.286H165.849C166.085 95.286 166.305 95.1965 166.463 95.0459C166.62 94.8962 166.703 94.6992 166.703 94.5V84.2246C166.703 84.0254 166.62 83.8284 166.463 83.6787C166.305 83.528 166.085 83.4386 165.849 83.4386L162.534 83.4386L160.781 81.7684H156.252Z",
    fill: "#303141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.5 91C159.605 91 160.5 90.1046 160.5 89C160.5 87.8954 159.605 87 158.5 87C157.395 87 156.5 87.8954 156.5 89C156.5 90.1046 157.395 91 158.5 91ZM158.5 93C160.709 93 162.5 91.2091 162.5 89C162.5 86.7909 160.709 85 158.5 85C156.291 85 154.5 86.7909 154.5 89C154.5 91.2091 156.291 93 158.5 93Z",
    fill: "#303141"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 317,
    height: 178,
    rx: 6,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferImagePlaceholder);
export default __webpack_public_path__ + "static/media/offer-image-placeholder.0b0cd1231f0068b289034f4ee8c81946.svg";
export { ForwardRef as ReactComponent };